import axios from "axios";
import AuthenticationFailureHandler from "../utils/AuthenticationFailureHandler";
import { BASE_URL, REPORTING_BASE_URL } from "../utils/EmpUtil";
import { is401 } from "../errors/ErrorConstants";

export default class NscReportingClient {
  static baseUrl = BASE_URL;
  static reportingUrl = REPORTING_BASE_URL;

  static downloadDealerActivationReportInCsv(user) {
    const url = `${
      this.baseUrl
    }/${user.generateResourcePath()}/activation-report`;
    return axios
      .get(url)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static async downloadDealerReservationSummary(user, market, catalog, vehicleLines) {
    try {

      let url = `${this.reportingUrl}/reporting/market-reservation-report?market=${encodeURIComponent(market)}`;

      if (vehicleLines?.length) {
        const matched = vehicleLines.find(
          vl => String(vl.catalogId).toLowerCase() === String(catalog).toLowerCase()
        );
        if (matched) {
          const model = encodeURIComponent(matched.model);
          const year = String(matched.year).split('.')[0];
          url += `&model=${model}&modelYear=${year}`;
        }
      }

      const { data } = await axios.get(url);
      return data;
    } catch (error) {
      if (is401(error)) {
        AuthenticationFailureHandler.execute();
      }
      return Promise.reject(error);
    }
  }
}
